import { muiGlobalTheme } from '@/muiGlobalTheme';

export const stylesSwitchFieldLabel = {
  m: 0,
  '.MuiFormControlLabel-label': {
    marginLeft: muiGlobalTheme.spacing(2),
  },
};
